import axios from "axios";
import { ENDPOINTS } from "../jsx/services/ENDPOINT";

const BASE_URL = `${ENDPOINTS.BASE_2}/vendors`;

// Get all vendors
export const getVendors = async () => {
  return await axios.get(BASE_URL);
};

// Create vendor
export const createVendor = async (data) => {
  return await axios.post(BASE_URL, data);
};

// Update vendor
export const updateVendor = async (id, data) => {
  return await axios.put(`${BASE_URL}/${id}`, data);
};

// Delete vendor
export const deleteVendor = async (id) => {
  return await axios.delete(`${BASE_URL}/${id}`);
};